
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Menu, X, Home, TestTube, Contact } from 'lucide-react';
import { Button } from '@/components/ui/button';

const Header: React.FC = () => {
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <header className="py-4 px-6 md:px-12 bg-white shadow-sm sticky top-0 z-50">
      <div className="container mx-auto flex justify-between items-center">
        <div 
          className="flex items-center cursor-pointer" 
          onClick={() => navigate('/')} 
          role="button"
          aria-label="Go to homepage"
        >
          <img 
            src="/lovable-uploads/941b0636-c487-4104-89e9-d13391561b0b.png" 
            alt="Morgen Health Logo" 
            className="h-10 md:h-12"
          />
        </div>
        
        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-6">
          <button 
            onClick={() => navigate('/')}
            className="font-satoshi font-medium transition-colors hover:text-morgenBlue flex items-center gap-2"
          >
            <Home size={18} />
            Home
          </button>
          <button 
            onClick={() => navigate('/quiz')}
            className="font-satoshi font-medium transition-colors hover:text-morgenBlue flex items-center gap-2"
          >
            <TestTube size={18} />
            Test
          </button>
          <button 
            onClick={() => navigate('/contact')}
            className="font-satoshi font-medium transition-colors hover:text-morgenBlue flex items-center gap-2"
          >
            <Contact size={18} />
            Contact
          </button>
        </nav>
        
        {/* Mobile Menu Button */}
        <div className="md:hidden">
          <Button variant="ghost" size="icon" onClick={toggleMobileMenu} aria-label="Toggle menu">
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </Button>
        </div>
      </div>
      
      {/* Mobile Navigation */}
      {mobileMenuOpen && (
        <div className="md:hidden absolute top-full left-0 right-0 bg-white shadow-md py-4 px-6 z-50 animate-fade-in">
          <nav className="flex flex-col space-y-4">
            <button 
              onClick={() => {
                navigate('/');
                setMobileMenuOpen(false);
              }}
              className="font-satoshi font-medium py-2 transition-colors hover:text-morgenBlue flex items-center gap-2"
            >
              <Home size={18} />
              Home
            </button>
            <button 
              onClick={() => {
                navigate('/quiz');
                setMobileMenuOpen(false);
              }}
              className="font-satoshi font-medium py-2 transition-colors hover:text-morgenBlue flex items-center gap-2"
            >
              <TestTube size={18} />
              Test
            </button>
            <button 
              onClick={() => {
                navigate('/contact');
                setMobileMenuOpen(false);
              }}
              className="font-satoshi font-medium py-2 transition-colors hover:text-morgenBlue flex items-center gap-2"
            >
              <Contact size={18} />
              Contact
            </button>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
